goog.provide("shadow.js.shim.module$react_use$lib$useKey");
goog.provide("module$shadow_js_shim_module$react_use$lib$useKey");
shadow.js.shim.module$react_use$lib$useKey = shadow.js.nativeProvides["react-use/lib/useKey"] = shadow$bridge("react-use/lib/useKey");
module$shadow_js_shim_module$react_use$lib$useKey.default = shadow.js.shim.module$react_use$lib$useKey;
